import React from 'react';
import './BlogListItem.css';

function formatDate(dateString) {
  const d = new Date(dateString);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  return `${year} · ${month}`;
}

export default function BlogListItem({ post }) {
  const { title, date, link } = post;

  return (
    <li className="blog-item">
      <span className="blog-date">{formatDate(date)}</span>
      <a href={link} target="_blank" rel="noopener noreferrer" className="blog-title">
        {title}
      </a>
    </li>
  );
}
